const NFT_CATEGORY = 'nfts'

export const NFT_EVENTS = {
  SEND: {
    action: 'Send NFTs',
    category: NFT_CATEGORY,
  },

  PREVIEW: {
    action: 'Preview NFT',
    category: NFT_CATEGORY,
  },
}
